import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import OutputError from "../OutputError";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FLWSEL01.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))
            return profiles.map(p => {
                const cs_list_left = row.data.filter(x => x.profile === p && x.side === 'left')
                const cs_list_right = row.data.filter(x => x.profile === p && x.side === 'right')

                let left = ''
                if(cs_list_left.length > 0) {
                    left = (
                        <>
                            <ResultText>The WSEL of {p} profile is higher than the left end elevation of the following {cs_list_left?.length} cross sections.</ResultText>
                            <ResultText><CheckCSName csNameList={cs_list_left?.map(x => x.cross_section)} /></ResultText>
                            <EmptyLine />
                        </>
                    )
                }

                let right = ''
                if(cs_list_right.length > 0) {
                    right = (
                        <>
                            <ResultText>The WSEL of {p} profile is higher than the right end elevation of the following {cs_list_right?.length} cross sections.</ResultText>
                            <ResultText><CheckCSName csNameList={cs_list_right?.map(x => x.cross_section)} /></ResultText>
                            <EmptyLine />
                        </>
                    )
                }

                return (
                    <>
                        {left}
                        {right}
                    </>
                )
            })
        }
        case MessageCodes.Internal.B20_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B20_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B20 = {
    RenderDescription,
}